<template>
  <div :class="{home}">
    <div class="card" v-if="shouldShowInstall && !home">
      <div class="card-body">
        <button type="button" class="btn-list download-app__install" @click="instalar()">
          <span class="download-app__icon mr-3" aria-hidden="true">
            <i :class="hasAndroidPlayStore ? 'fa-brands fa-google-play' : 'fa-solid fa-download'"></i>
          </span>
          <span class="download-app__install-copy">
            <span class="h6 font-weight-bold d-block mb-0">Baixar o App</span>
            <span class="small font-weight-bold" style="color: #a3c613">Instalar agora</span>
          </span>
          <i class="fa-solid fa-angle-right ml-auto pl-3 text-muted" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="card download-app" v-else-if="shouldShowInstall">
      <div class="text-theme text-decoration-none">
        <div class="container-fluid p-0">
          <div class="row no-gutters">
            <div class="col-9 d-flex align-items-center download-app__content" @click="instalar()">
              <div class="download-app__icon mr-3">
                <i :class="hasAndroidPlayStore ? 'fa-brands fa-google-play' : 'fa-solid fa-download'"></i>
              </div>
              <div>
                <h6 class="font-weight-bold mb-1">Baixar o App</h6>
                <div class="small download-app__subtitle">
                  <b class="download-app__cta">
                    Instalar agora
                  </b>
                </div>
              </div>
            </div>
            <div class="col-3 text-right download-app__close-wrap" v-if="home">
              <button type="button" class="btn download-app__close" @click.prevent="close(true)" aria-label="Fechar aviso">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512" fill="currentColor" aria-hidden="true"><path d="M27.1 1.1c-10.4 2-19.4 9.1-23.9 18.7C1 24.5.5 26.9.5 33.5c0 15.5-6.8 7.8 107.5 122l101 101-101.9 102C24.4 441.4 4.9 461.4 3 465.5c-3.4 7.1-3.5 19.9-.2 27 2.9 6.3 9.3 12.9 15.7 16.3 7.2 3.7 18.7 4.2 27 1.2 5.8-2.2 9.4-5.6 108.3-104.4L256 303.5l101.8 101.6c81.7 81.6 102.7 102.1 106.7 104 4.2 2 6.5 2.4 14.5 2.4 8.3 0 10.1-.4 14.5-2.7 6.2-3.2 12.9-10.3 15.8-16.6 3.2-6.8 3-19.7-.3-26.7-1.9-4.1-21.4-24.1-104.1-107L303 256.5l101-101C518.3 41.3 511.5 49 511.5 33.5c0-6.5-.5-9-2.6-13.5-8.1-17.2-28.4-24.2-45.4-15.8-2.6 1.3-39.1 37-105.7 103.6L256 209.5 154.3 107.8C87.6 41.2 51.1 5.5 48.5 4.2 45.1 2.5 34-.3 32.1.1c-.3.1-2.6.5-5 1"/></svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-bottom v-model="modalDownload" title="Instalar aplicativo">
      <div class="download-app__modal">
        <div class="download-app__img">
          <img src="../assets/icone.png" alt="Logo da empresa">
        </div>
        <p>
          Instale o App e garanta ainda mais rapidez no seu próximo pedido.
        </p>
        <div v-if="isIOSSafari">
          <p class="ios-app download-app__ios-steps">
            1. Clique em
            <img src="../assets/infoSafari.png" style="width: 22px" alt="Três pontinhos">
            <br>
            2. Selecione <b>Compartilhar</b>
            <br>
            3. Toque novamente em
            <img src="../assets/infoSafari.png" style="width: 22px" alt="Três pontinhos">
            <br>
            4. Escolha: <b>Adicionar à Tela de Início</b>
          </p>
          <div class="download-app__arrow">
            <img src="../assets/arrow.png" alt="Seta">
          </div>
        </div>
        <div v-else>
          <p>Clique nos três pontinhos do canto superior direito e depois em <b>“Adicionar à tela inicial”.</b></p>
        </div>
      </div>
      <template #footer v-if="!isIOSSafari">
        <button class="btn btn-outline-primary" @click="close()">Agora não</button>
      </template>
    </modal-bottom>
  </div>
</template>

<script>
  import { Capacitor } from '@capacitor/core';
  import ModalBottom from "./ModalBottom";

  export default {
    name: "DownloadApp",
    components: {ModalBottom},
    props: ['home'],

    data() {
      return {
        dismissed: sessionStorage.getItem('closeApp') === '1',
        modalDownload: false
      }
    },

    methods: {
      close(closeUrl) {
        this.modalDownload = false;

        if (closeUrl) {
          sessionStorage.setItem('closeApp', '1');
          this.dismissed = true;
        }
      },

      async instalar() {
        if (this.hasAndroidPlayStore) {
          window.location.href = this.playStoreUrl;

        } else if (this.prompt) {
          const installPrompt = this.prompt;

          try {
            await installPrompt.prompt();
            await installPrompt.userChoice;
          } finally {
            this.$store.commit('setPrompt', null);
          }

        } else if (this.isIOSSafari) {
          this.modalDownload = true;
        }
      }
    },

    computed: {
      prompt() {
        return this.$store.state.pwaPrompt;
      },

      playStoreUrl() {
        return (process.env.VUE_APP_PLAY_STORE_URL || '').trim();
      },

      hasAndroidPlayStore() {
        return this.isAndroid && Boolean(this.playStoreUrl);
      },

      isStandalone() {
        return window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches;
      },

      isIOSSafari() {
        const userAgent = window.navigator.userAgent;
        const isIOS = /iPhone|iPad|iPod/i.test(userAgent) ||
          (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
        const isSafari = /Safari/i.test(userAgent) && !/CriOS|FxiOS|EdgiOS|OPiOS/i.test(userAgent);
        return isIOS && isSafari;
      },

      shouldShowInstall() {
        return (!this.home || !this.dismissed) &&
          !Capacitor.isNativePlatform() &&
          (!this.isStandalone || this.hasAndroidPlayStore) &&
          (!this.$store.state.pwaInstalled || this.hasAndroidPlayStore) &&
          Boolean(this.hasAndroidPlayStore || this.prompt || this.isIOSSafari);
      }
    }
  }
</script>

<style scoped>
  .download-app__install {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0;
    width: 100%;
    background: transparent;
    border: 0;
    text-align: left;
    font: inherit;
    color: var(--text-default);
    cursor: pointer;
  }

  .download-app {
    padding: 14px 12px 14px 14px;
    background: var(--bg-theme-secondary);
    border-radius: 24px;
    border: 1px solid var(--border-color);
    box-shadow: 0 10px 24px rgba(22, 24, 22, 0.05);
  }

  .home .download-app {
    margin-bottom: 18px;
  }

  .download-app__img {
    width: 60px;
    margin: 8px auto 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .download-app__img img {
    width: 60px;
  }

  .download-app__content {
    padding-left: 8px;
  }

  .download-app__modal {
    position: relative;
    padding-top: 8px;
  }

  .download-app__arrow {
    margin-top: 1.5rem;
    text-align: right;
    padding-right: 15px;
  }

  .download-app__arrow img {
    width: 42px;
  }

  .download-app__ios-steps {
    padding-left: 8px;
    margin-bottom: 0;
  }

  .download-app__icon {
    width: 48px;
    height: 48px;
    border-radius: 16px;
    background-color: rgba(199, 244, 123, 0.22);
    border: 1px solid rgba(199, 244, 123, 0.34);
    color: #a3c613;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .download-app__icon i {
    font-size: 1.12rem;
  }

  .download-app__subtitle {
    color: var(--text-muted);
  }

  .download-app h6 {
    font-size: 1.05rem;
    line-height: 1.2rem;
  }

  .download-app__subtitle {
    font-size: 0.88rem;
    line-height: 1rem;
  }

  .download-app__cta {
    color: #a3c613;
    display: inline-flex;
    align-items: center;
  }

  .download-app__close-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .download-app__close {
    min-height: 36px;
    width: 36px;
    padding: 0;
    border-radius: 12px;
    border: 1px solid var(--border-color);
    color: var(--text-muted);
    background-color: var(--bg-theme-secondary);
  }

  .dark-mode .download-app {
    background: var(--bg-elevated);
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.16);
  }

  .dark-mode .download-app__cta {
    color: var(--primary);
  }

  .dark-mode .download-app__icon {
    background-color: rgba(199, 244, 123, 0.14);
    border-color: rgba(199, 244, 123, 0.2);
    color: var(--primary);
  }

  @media (max-width: 576px) {
    .download-app__content {
      padding-left: 28px;
    }

    .download-app__ios-steps {
      padding-left: 12px;
    }
  }
</style>
